export const DEFAULT_LATITUDE = 37.6046992;
export const DEFAULT_LONGITUDE = 126.8602852;
export const DEFAULT_ZOOM = 9;
export const GAP_MAP_ZOOM_LEVEL = {
  sido: 10,
  sigungu: 11,
  dong: 12,
  complex: 13,
};
